import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import MarketingNav from "@/components/Layout/MarketingNav";
import MarketingFooter from "@/components/Layout/MarketingFooter";
import Markdown from "@/components/Markdown";
import { fmtDate } from "@/lib/format";

export default function LegalPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    setErr(null);
    setPage(null);
    api.get(`/legal/${slug}`).then((r) => setPage(r.data)).catch(() => setErr("Page not found"));
  }, [slug]);

  return (
    <div className="min-h-screen bg-background">
      <MarketingNav />
      <section className="max-w-3xl mx-auto px-6 sm:px-10 pt-16 pb-24">
        {err && <div className="text-muted-foreground">{err}</div>}
        {page && (
          <>
            <div className="label-eyebrow mb-4">Legal · last updated {fmtDate(page.updated_at)}</div>
            <h1 className="heading-display text-4xl sm:text-5xl mb-8" data-testid="legal-title">{page.title}</h1>
            <Markdown className="text-foreground" data-testid="legal-content">{page.content}</Markdown>
          </>
        )}
      </section>
      <MarketingFooter />
    </div>
  );
}
